<template>
    <div id="contendedor-fecha-hora-revisado-switch">
            <v-switch
            v-model="fechaHoraRevisadoCheck"
            color="primary"
            inset
            :loading="enviandoFormulario"
            @change="guardar">
        </v-switch>
    </div>
</template>

<script>
import ACTUALIZAR_CONTRATO_REPORTE_FISICO_FECHA_HORA_REVISADO from '@/graphql/mutations/administracion/ejecuccion/reportesFisicos/actualizarContratoReporteFisicoFechaHoraRevisado.gql';
import CONTRATO_REPORTES_FISICOS from '@/graphql/querys/administracion/ejecucion/reportesFisicos/contratoReportesFisicos.gql';

export default {
  name: 'FechaHoraRevisadoSwitch',
  props: {
    reporteFisico: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      fechaHoraRevisadoCheck: !!this.reporteFisico.fechaHoraRevisado,
      fechaHoraRevisado: null,
    };
  },
  methods: {
    async guardar() {
      if (this.reporteFisico.fechaHoraRevisado) {
        this.fechaHoraRevisado = null;
      } else {
        this.fechaHoraRevisado = new Date();
      }
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_REPORTE_FISICO_FECHA_HORA_REVISADO,
          variables: {
            id: this.reporteFisico.id,
            fechaHoraRevisado: this.fechaHoraRevisado,
          },
          update: (store, { data: { actualizarContratoReporteFisicoFechaHoraRevisado } }) => {
            const query = {
              query: CONTRATO_REPORTES_FISICOS,
              variables: {
                idContrato: this.reporteFisico.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoReportesFisicos } = data;
            const index = contratoReportesFisicos
              .findIndex((item) => item.id === actualizarContratoReporteFisicoFechaHoraRevisado.id);
            if (index !== -1) {
              contratoReportesFisicos
                .splice(index, 1, actualizarContratoReporteFisicoFechaHoraRevisado);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
